import React from 'react';

import SuluxLogo from '../Logo';
import FooterItem from './footerItem';

const footerItems = [
    {
        header:"Customer Services",
        list:[
            {
                target:"/",
                title:"Contact Us"
            },
            {
                target:"/",
                title:"About us"
            }
        ]
    },
    {
        header:"Sulux Watches",
        list:[
            {
                target:"/",
                title:"Brand A-Z"
            },
            {
                target:"/",
                title:"Pre-Owned"
            },
            {
                target:"/",
                title:"News"
            }
        ]
    },
    {
        header:"Information",
        list:[
            {
                target:"/",
                title:"Delivery"
            },
            {
                target:"/",
                title:"Click & Collect"
            },
            {
                target:"/",
                title:"Return"
            },
            {
                target:"/",
                title:"Frequently Asked Questions"
            }
        ]
    },
    {
        header:"Secure Shopping",
        list:[
            {
                target:"/",
                title:"Privacy Policies"
            },
            {
                target:"/",
                title:"Cookie Policy"
            },
            {
                target:"/",
                title:"Terms & Conditions"
            },
            {
                target:"/",
                title:"Terms of Use"
            }
        ]
    },
    
]
const Footer = () => {
    const d= new Date();
    return(
        <div className="c-footer py-56 lg:py-32  px-32 border-1 border-r-0 border-l-0 border-gray-400  xl:px-144">
            <div className="-mx-16 flex flex-wrap ">
                <div className="px-16 w-full lg:w-2/12 order-2 lg:order-1">
                    <div className="text-center flex justify-center mb-30 lg:mb-10 lg:text-left lg:justify-start">
                        <SuluxLogo/>
                    </div>
                    <div className="text-center text-sm text-gray-500 lg:text-left">
                        <span className="text-lg">&copy;</span> Copyright {d.getFullYear()}. All Rights Reserved.
                    </div>
                </div>
                <div className="px-16 w-full lg:w-10/12 order-1 lg:order-2 lg:flex ">
                    {
                        footerItems.map((item,i)=>{
                        return( 
                                <FooterItem header={item.header} list={item.list} key={i}/>
                            );  
                        })
                    } 
                </div>
            </div>
        </div>
    )
}
export default Footer;